import { FinishingListProps } from "@/app/types/types";

const FinishingTabs = ({data , activeTab , handleTabClick} : {data : FinishingListProps[] , activeTab : number , handleTabClick : (id : number) => void }) => {
  return (
    <ul className="FinishingComponent_tabs-list flex flex-row justify-start lg:justify-center items-center overflow-scroll ">
    {data?.map((item) => (
      <li
        key={item.id}
        onClick={() => handleTabClick(item.id)}
        className={`FinishingComponent_tabs-list-item mr-3 px-8 py-3 rounded-full cursor-pointer uppercase whitespace-nowrap  ${
          activeTab === item.id
            ? "bg-[#FFF] text-[#081629]"
            : "bg-oBlack-10 text-[#081629]"
        }`}
      >
        {item?.title?.en}
      </li>
    ))}
  </ul>
  );
}

export default FinishingTabs;